import { ConnectedInstance, useAuth, useUpdateEffect, useView, userMode, BreakpointConfiguration } from '@10000/react'
import { Background, ScaledScreen, Shell, Stack, useStack } from './layout'
import { Home } from './home'
import { Host } from './squiz'
import { Kiosk } from './kiosk'
import { Authenticate, SignUp } from './auth'
import { Onboarding, useOnboardingStack } from './onboarding'
import { SuperRouter } from './super'
import { SelectMode } from './free'
import { query } from '../utilities.js'
import { isFree } from '../lookups'

const persistedUser = (window.localStorage['socket.authenticatedUser'] && window.localStorage['socket.authenticatedUser'] !== 'undefined')
  ? JSON.parse(window.localStorage['socket.authenticatedUser']) : {}
const fromUrl = query()

export function Router() {
  const { region, tenantId } = persistedUser

  return (
    <BreakpointConfiguration breakpoints={{
      mobile: ({ width }) => width <= 600,
      constrained: ({ width }) => width <= 1200
    }}>
      <ConnectedInstance
        entity="tenant"
        aggregates={['tenant', 'results']}
        topic="tenantInput"
        region={region}
        id={tenantId}
        allowDisconnected={!tenantId}
      >
        {fromUrl.view === 'display'
          ? <ScaledScreen>
              <StackWrapper limitHeight={false} region={region} />
            </ScaledScreen>
          : <StackWrapper />
        }
      </ConnectedInstance>
    </BreakpointConfiguration>
  )
}

const StackWrapper = ({ limitHeight, region }) => {
  const controllerData = useControllerData()
  const onboardingStack = useOnboardingStack()
  const { user } = useAuth()
  const initialStack = onboardingStack || [getComponent(controllerData, true)]
  return (
    ((user?.super && userMode() === 'super') && !fromUrl.instanceId)
      ? <SuperRouter region={region} />
      : <Background>
          <Stack Wrapper={Shell} initialStack={initialStack} limitHeight={limitHeight}>
            <Controller />
            <Onboarding />
          </Stack>
        </Background>
  )
}

const Controller = () => {
  const { instanceId, region, view, kiosk, authenticated, onboard, free } = useControllerData()
  const { replaceStack } = useStack()

  useUpdateEffect(() => {
    if(onboard || free) {
      const { Component, props } = getComponent(
        { instanceId, region, view, kiosk, authenticated, onboard, free }
      ) || {}
      if(Component) {
        replaceStack(Component, { props })
      }
    }
  }, [replaceStack, instanceId, region, view, kiosk, authenticated, onboard, free])

  return null
}

const useControllerData = () => {
  const { authenticated, user } = useAuth()
  const { currentSquiz, user: { onboard } = {}, subscription } = useView('tenant')
  const { instanceId, region, view } = Object.assign(
    { view: (authenticated && !fromUrl.instanceId) ? 'presenter' : undefined },
    currentSquiz,
    fromUrl
  )
  const kiosk = user.groups?.includes('kiosk')
  const free = isFree(subscription)
  return { instanceId, region, view, kiosk, authenticated, onboard, free }
}

const getComponent = ({ instanceId, region, view, kiosk, authenticated, onboard, free }, initial) => {
  if(instanceId && region) {
    return {
      Component: Host,
      props: { instanceId, view, region }
    }
  } else if(kiosk) {
    return { Component: Kiosk }
  } else if(authenticated && onboard && !free) {
    return { Component: Home }
  } else if(authenticated && free) {
    return { Component: SelectMode }
  } else if(initial) {
    if(Object.hasOwn(fromUrl, 'signup')) {
      window.history.replaceState({}, '', window.location.pathname) // remove querystring parameter
      return { Component: SignUp }
    } else if(Object.hasOwn(fromUrl, 'free')) {
      return { Component: SignUp, props: { free: true } }
    } else {
      return { Component: Authenticate }
    }
  }
}